import React, { useState } from "react";
import HeroLayout from "../components/HeroLayout";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import PhoneNumberField from "../components/PhoneNumberField";
const images = require.context("../assets/images", false);

function TailorMade() {
  const [formData, setFormData] = useState({
  name: "",
  email: "",
  nationality: "",
  countryCode: "+91",
  phone: "",
  places: "",
  travel_dates: "",
  child: "",
  adult: "",
  hotel: "",
  vehicle: "",
  message: ""
});

const [captchaToken, setCaptchaToken] = useState(null);
const [loading, setLoading] = useState(false);
const [errors, setErrors] = useState({});
const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    setErrors({
      ...errors,
      [e.target.name]: ""
    });
  };
const validate = () => {
  let newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Name is required";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    newErrors.email = "Invalid email format";
  }

  if (!formData.nationality.trim()) {
    newErrors.nationality = "Nationality is required";
  }

  if (!formData.phone.trim()) {
    newErrors.phone = "Phone number is required";
  } else if (!/^[0-9]{7,15}$/.test(formData.phone)) {
    newErrors.phone = "Enter valid phone number";
  }

  if (!formData.places.trim()) {
    newErrors.places = "Please enter places you want to visit";
  }

  if (!formData.travel_dates.trim()) {
    newErrors.travel_dates = "Travel dates are required";
  }
   if (!formData.adult.trim()) {
    newErrors.adult = "Number of adults is required";
  }
  


/*
  if (!formData.message.trim()) {
    newErrors.message = "Message is required";
  }
  */

  return newErrors;
};


const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validate();

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  try {
    if (!captchaToken) {
  setErrors({ captcha: "Please verify captcha" });
  return;
}
    setLoading(true);

    const response = await fetch(
      "https://www.luxurygoldentriangle.com/bkadmn/wp-json/custom/v1/contact_tailormade",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          phone: `${formData.countryCode} ${formData.phone}`.trim(),
          captcha: captchaToken
        })
      }
    );

    const data = await response.json();

    if (data.success) {
    setSuccess("Message sent successfully!");
    setErrors({ captcha: "" });
      setFormData({
        name: "",
        email: "",
        nationality: "",
        countryCode: "+91",
        phone: "",
        places: "",
        travel_dates: "",
        child: "",
        adult: "",
        hotel: "",
        vehicle: "",
        message: ""
      });

      setCaptchaToken(null);
    } else {
      setSuccess(data.message || "Something went wrong.");
    }

  } catch (error) {
    setSuccess("Server error. Please try again.");
  } finally {
    setLoading(false);
  }
};



  return (
    <>
    <HeroLayout>
    <div
    className="banner-bg bg-bottom"
    style={{
        backgroundImage:
        `linear-gradient(#370b2e66, #370b2e66), url(${images("./ab.webp")})`
    }}
    >
    <div className="container">
        <div className="inner-banner-content full-width center color-white mt-5">
        <h1>Tailor Made Tour</h1>
        </div>
    </div>
    </div>

    </HeroLayout>
    <div className="contact-form mt-80">
  <img className="center-left-position" src={images("./taj-mahal.svg")} />
  <img className="center-right-position" src={images("./peacock.svg")} />
  <img className="top-right-position" src={images("./dance-man.svg")} />
  <img className="bottom-left-position" src={images("./tiger.svg")} />
  <img className="top-left-position" src={images("./dance-girl.svg")} />
  <img className="bottom-right-position" src={images("./elephant.svg")} />
  <div className="container">
    <div className="heading center">
      <h2 className="tailormadh">TAILOR MADE TOUR - YOUR STYLE, YOUR PREFERENCE</h2>
      <p>
        If you are not into brochure tours and looking for something especially
        customized as per your preferences and travel style, our team will do
        that for you happily. Please fill this form below and we will get back
        to you soon with your tour details.
      </p>
    </div>
    <div className="form-card">
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">Name<span>*</span></label>

              <input
  type="text"
  name="name"
  className="form-control"
  value={formData.name}
  onChange={handleChange}
  placeholder="Enter your name"
/>

{errors.name && <p className="error">{errors.name}</p>}

            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">Email<span>*</span></label>
<input
  type="email"
  name="email"
  className="form-control"
  value={formData.email}
  onChange={handleChange}
  placeholder="Enter your email"
/>

{errors.email && <p className="error">{errors.email}</p>}

            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">Nationality<span>*</span></label>

              <input
  type="text"
  name="nationality"
  className="form-control"
  value={formData.nationality}
  onChange={handleChange}
  placeholder="Enter your nationality"
/>

{errors.nationality && <p className="error">{errors.nationality}</p>}

            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <PhoneNumberField
              countryCode={formData.countryCode}
              value={formData.phone}
              onChange={handleChange}
              error={errors.phone}
            />
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">Desired Places to Visit<span>*</span></label>

              <input
  type="text"
  name="places"
  className="form-control"
  value={formData.places}
  onChange={handleChange}
  placeholder="Enter your desired places"
/>

{errors.places && <p className="error">{errors.places}</p>}

            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">
                Preferred Travel Dates &amp; Tour Duration<span>*</span>
              </label>

                            <input
  type="text"
  name="travel_dates"
  className="form-control"
  value={formData.travel_dates}
  onChange={handleChange}
  placeholder="Enter your preferred travel dates & tour duration"
/>

{errors.travel_dates && <p className="error">{errors.travel_dates}</p>}
            </div>
          </div>

          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">Number of travelers (Adult - 12 years and above)<span>*</span></label>
               <input
  type="number"
  name="adult"
  className="form-control"
  value={formData.adult}
  onChange={handleChange}
  placeholder="Enter number of adults"
/>

{errors.adult && <p className="error">{errors.adult}</p>}

            </div>
          </div>
		            <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">Number of travelers (Child - below 12 years)</label>
                              <input
  type="number"
  name="child"
  className="form-control"
  value={formData.child}
  onChange={handleChange}
  placeholder="Enter number of child(ren)"
/>

{errors.child && <p className="error">{errors.child}</p>}          
            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">
                Hotel Preference (<Link to="/5-star-luxury-hotels" className="text-decorationunderline">see list of hotels<span>here</span></Link>)
              </label>
              <div className="preference-options">
                <div className="preference-option">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="radio1">
   
                      <input
                        id="radio1"
                        type="radio"
                        name="hotel"
                        value="5 Star"
                        checked={formData.hotel === "5 Star"}
                        onChange={handleChange}
                      />
                      5 Star
                    </label>
                  </div>
                </div>
                <div className="preference-option">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="radio2">
                      <input
                        id="radio2"
                        type="radio"
                        name="hotel"
                        value="5 Star luxury"
                        checked={formData.hotel === "5 Star luxury"}
                        onChange={handleChange}
                      />

                      5 Star luxury
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">
                Car Preference (
                <Link to="/car-details" className="text-decorationunderline">see list of car/vehicles<span>here</span></Link>)
              </label>
              <div className="preference-options">
                <div className="preference-option">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="radio3">
                      <input
  id="radio3"
  type="radio"
  name="vehicle"
  value="Standard Muv"
  checked={formData.vehicle === "Standard Muv"}
  onChange={handleChange}
/>

                      Standard Muv
                    </label>
                  </div>
                </div>
                <div className="preference-option">
                  <div className="form-check">
                    <label className="form-check-label" htmlFor="radio4">

                                        <input
  id="radio4"
  type="radio"
  name="vehicle"
  value="Upgraded luxury vehicle"
  checked={formData.vehicle === "Upgraded luxury vehicle"}
  onChange={handleChange}
/>
                      Upgraded luxury vehicle
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-input-group mb-2">
              <label htmlFor="name">Message</label>
              <textarea
  name="message"
  className="form-control"
  placeholder="Kindly mention your requirements in detail, so that we can customize your tour accordingly."
  value={formData.message}
  onChange={handleChange}
/>

            </div>
          </div>
                            <div className="col-md-12">
                <ReCAPTCHA
                  sitekey="6Ld4kHosAAAAAKsayfQ1saymv6SeauUSxkHSn55b"
                  onChange={(token) => setCaptchaToken(token)}
                />
                {errors.captcha && <p className="error">{errors.captcha}</p>}
                </div>
        </div>
        <div className="form-btn center mt-3">
              <button type="submit" disabled={loading} className="primary-btn">
                {loading ? "Sending..." : "Submit"} <img src={images("./arrow-right-btn.svg")} alt="Arrow" />
              </button>
          {success && <p className="success">{success}</p>}
        </div>
      </form>
    </div>
  </div>
</div>

    </>
  );
}

export default TailorMade;
